(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adb-product-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const link = event.target.closest('.adb-hub__area-links a[href^="#brand-"]');
    if (!link) return;
    const group = document.getElementById(link.hash.slice(1));
    if (group?.matches('details')) group.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adb-welcome"]) return;
  try {
    
  if (!customElements.get('adb-welcome')) {
    customElements.define('adb-welcome', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const key = 'adb-welcome-dismissed-v1';
        try { if (sessionStorage.getItem(key)) return; } catch (_) { /* Storage is optional. */ }
        const close = () => {
          this.hidden = true;
          try { sessionStorage.setItem(key, '1'); } catch (_) { /* Storage is optional. */ }
        };
        this.querySelector('button').addEventListener('click', close);
        this.querySelector('a').addEventListener('click', close);
        this.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
        this.timer = setTimeout(() => {
          // Do not interrupt a dialog, consent banner, search field or checkout task.
          if (document.querySelector('dialog[open], [aria-modal="true"], #shopify-pc__banner') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '')) return;
          this.hidden = false;
        }, 2500);
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
